export default __webpack_public_path__ + "static/media/PolyDoge.60badda3.png";